<h1 mat-dialog-title
    class="draggable-dialogue-header"
    cdkDrag
    cdkDragRootElement=".cdk-overlay-pane"
    cdkDragHandle>
    Copy Form
</h1>

<form>
    <div mat-dialog-content>
        <div class="source-form-div">
            Source Form:
            <span class="source-form-name-span">{{this.SourceFormName}}</span>
        </div>

        <mat-form-field appearance="outline"
                        class="form-copy-name-mat-form-field">
            <mat-label>Form Copy Name</mat-label>
            <input matInput
                   [(ngModel)]="this.FormCopyName"
                   placeholder="Name for Copied Form"
                   [disabled]="false"
                   name="formCopyName"
                   autocomplete="off"
                   required />
        </mat-form-field>
    </div>

    <!--
    <div class="execution-time-div">
        <span>Execution Time:</span>
        <span [ngClass]="this.CopyInitiated ? 'active-execution-time-span' : 'idle-execution-time-span'">{{this.JobTimeElapsed}}</span>
    </div>
        -->

    <div class="execution-status-div">
        <span>Execution Status:</span>
        <span [ngClass]="this.CopyInitiated ? 'completed-execution-status-span' : 'incomplete-execution-status-span'">{{this.CopyStatus}}</span>
    </div>

    <div mat-dialog-actions>
        <button mat-flat-button
                type="submit"
                color="primary"
                class="theme-primary-btn"
                [disabled]="(!this.FormCopyName) || (this.FormCopyName.trim().length == 0) || this.CopyInitiated"
                (click)="this.startFormCopy()">
            Copy
        </button>
        <button mat-flat-button
                [disabled]="this.CopyInitiated"
                [mat-dialog-close]="null"
                class="cancel-button">
            Cancel
        </button>
    </div>
</form>
